import {
  UploadImageComponent,
  UploadImageDialogData,
} from '../../../../../modules/shared/components/dialogs/upload-image/upload-image.component';
import { ApiService } from './../../../services/api.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../../../abstraction/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';
import { DOCUMENT_TYPE } from '../../../models/User';
import { ISelectValue } from 'src/app/modules/shared/components/selector/selector.component';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss'],
})
export class DocumentationComponent implements OnInit, AfterViewInit {
  operationLimits = {
    monthly: {
      operated: 0,
      limit: 0,
    },
    yearly: {
      operated: 0,
      limit: 0,
    },
  };
  depositLimits = {
    monthly: {
      limit: 0,
      deposited: 0,
    },
    yearly: {
      limit: 0,
      deposited: 0,
    },
  };
  userLimits = {
    operation: {},
    deposit: {},
  };
  depositTime: string = 'monthly';
  operationTime: string = 'monthly';
  fundOriginSent = false;
  isCommerce = false;
  optionsTime: ISelectValue[] = [
    { label: 'Mensual', value: 'monthly' },
    { label: 'Anual', value: 'yearly' },
  ];
  constructor(
    public api: ApiService,
    public auth: AuthService,
    public router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.getLimits();
    this.isCommerce = this.auth.loggedUser.isCommerce;
  }

  ngAfterViewInit(): void {
    this.route.fragment.subscribe((fragment: string) => {
      if (fragment && document.getElementById(fragment)) {
        document.getElementById(fragment).scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  getLimits() {
    this.api.getUserLimits().subscribe((res) => {
      this.operationLimits = {
        monthly: {
          operated: +res.monthLimit - +res.monthLeft,
          limit: res.monthLimit,
        },
        yearly: {
          operated: +res.yearLimit - +res.yearLeft,
          limit: res.yearLimit,
        },
      };
      this.depositLimits = {
        monthly: {
          limit: res.monthLimit,
          deposited: res.totalDepositedMonthly,
        },
        yearly: {
          limit: res.yearLimit,
          deposited: res.totalDepositedYearly,
        },
      };
    });
  }

  openFundOriginModal() {
    if (!this.auth.hasValidatedDNIS()) {
      this.openAlertDialog({
        title: 'Falta validar verificación de identidad',
        content:
          'Debe primero subir una verificación de identidad y esperar a que se lo valide el sistema.',
      });
      return;
    }
    const refs = this.openUploadImageWindow(
      'Subir origen de fondos',
      'Debe subir un archivo que muestre su origen de fondos.',
      ['SUBIR'],
    );
    refs.afterClosed().subscribe((uploadedImage) => {
      this.fundOriginSent = uploadedImage ? true : false;
    });
  }

  openAlertDialog(data: AlertDialogData) {
    return this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, { data });
  }

  openUploadImageWindow(title, body, options = ['Aceptar']) {
    const ref = this.dialog.open<UploadImageComponent, UploadImageDialogData>(
      UploadImageComponent,
      {
        panelClass: 'modal-container',
        data: {
          title,
          body,
          options,
          documentType: DOCUMENT_TYPE.FUNDS,
          successMessage:
            'Origen de fondos subido con éxito! <br> La resolución sobre la documentación presentada la recibís en tu email, dentro de las 24 hs hábiles siguientes.',
        },
      },
    );
    return ref;
  }
}
